"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushQueryValues = void 0;
const react_1 = require("react");
const router_1 = __importStar(require("next/router"));
const query_string_1 = __importDefault(require("query-string"));
const constants_1 = require("../utils/constants");
const pushQueryValues = (values) => {
    const { pathname, query } = router_1.default;
    const { search } = location;
    const queryObject = Object.assign(Object.assign(Object.assign(Object.assign({}, query_string_1.default.parse(search)), query), values), { deviceType: undefined, variant: undefined });
    const queryString = query_string_1.default.stringify(queryObject);
    const pathnameSplit = pathname.split(constants_1.STATIC_PAGES_PATH);
    const nextPathname = pathnameSplit.length > 1 ? pathnameSplit[1] : pathname;
    router_1.default.push(`${nextPathname}${queryString ? `?${queryString}` : ''}`, undefined, {
        shallow: true,
    });
};
exports.pushQueryValues = pushQueryValues;
const usePushQueryValue = (defaultValue, queryKey) => {
    const { query } = (0, router_1.useRouter)();
    const queryValue = query[queryKey];
    const pushValue = (0, react_1.useCallback)((value) => (0, exports.pushQueryValues)({ [queryKey]: value }), []);
    return [queryValue || defaultValue, pushValue];
};
exports.default = usePushQueryValue;
//# sourceMappingURL=usePushQueryValue.js.map